<template>
  <li class="swiper-slide">
    <a href="#" @click.prevent="selectCell">
      <template v-if="isProgress">
        <div class="circle-progress">
          <vue-circle
            :progress="cellInfo.progress * 100"
            :size="84"
            :reverse="false"
            line-cap="butt"
            :fill="fill"
            empty-fill="rgba(0, 0, 0, .3)"
            :animation-start-value="0.0"
            :start-angle="4.8"
            insert-mode="append"
            :thickness="3"
            :show-percent="false">
          </vue-circle>
        </div>
        <div class="circle-img">
          <img :src="getCircleImage" :alt="altTitle"/>
        </div>
      </template>
      <template v-else>
        <div class="circle-img">
          <img v-lazy="getCircleImage" :alt="altTitle"/>
        </div>
      </template>
      <div class="cell-info">
        <div class="cell-title-wrap" v-title-list="{'titleList': titleList}"></div>
      </div>
    </a>
  </li>
</template>
<script>
import VueCircle from 'vue2-circle-progress/src/index.vue'
import { resizeThumbnail } from '@/common/image.filter'
import { get } from 'lodash'
import cellMixin from '@/common/mixin/cell.mixin'
import { titleList } from '@/common/directives'
export default {
  name: 'CircleCell',
  components: {
    VueCircle
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    cellIndex: {
      type: Number
    }
  },
  directives: {
    titleList
  },
  mixins: [
    cellMixin
  ],
  data () {
    return {
      fill: { gradient: [['#1351f9', 1], ['#1351f9', 0]] }
    }
  },
  computed: {
    getCircleImage () {
      return resizeThumbnail(get(this.cellInfo, 'thumbnail', ''), { width: 110, height: 110, quality: 75, isSquare: true, multiply: 3 })
    }
  }
}
</script>
